import { Tool } from "../Tool";
import * as React from "react";
import { useDrag } from "react-dnd";
import { DragableTypes } from "../../constants/DragableTypes";
import { BinTypes } from "../../constants/BinTypes";
import { ToolTypes } from "../../constants/ToolTypes";
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import { Tooltip } from "@mui/material";
import { useTranslation } from 'react-i18next';

export default function ZoomAndPanTool({ handleFinishToolDragging }) {

    const { t } = useTranslation();

    const tool = {
        id: ToolTypes.ZOOM_AND_PAN,
        duration: "5",
        type: BinTypes.TOOL,
        toolType: ToolTypes.ZOOM_AND_PAN,
        displayName: t("tools.zoom-and-pan")
    }
    const [{ opacity }, dragRef] = useDrag(
        () => ({
            type: DragableTypes.PLAIN_TOOL,
            item: tool,
            collect: (monitor) => ({
                opacity: monitor.isDragging() ? 0.5 : 1,
            }),
            end: (item, monitor) => handleFinishToolDragging(monitor.getDropResult(), tool.toolType),
        }),
        []
    )

    return (
        <Tooltip title={ tool.displayName }>
            <Tool
                ref={dragRef}
                variant="outlined"
                square
                style={{ opacity, border: "none" }}
            >
                <CenterFocusStrongIcon sx={{ fontSize: 120, color: "#2adb68", width: "100%", height: "100%" }} />
            </Tool>
        </Tooltip>
    )
}